import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { setHtmlLang } from './util/lang';

Vue.use(Vuex);

const localStoragePlugin = (store: Store<any>) => {
  // 当 store 初始化后调用
  store.subscribe((mutation, state) => {
    if (mutation.type === 'setLang') {
      window.localStorage.setItem('lang', state.lang);
      setHtmlLang(state.lang);
    }
  });
};

export default new Vuex.Store({
  state: {
    lang: 'zh-CN',
    showbar: false,
    toolbarItems: [],
    toolbarActive: '1',
    // 在线客服侧边栏是否打开 true 表示打开
    onlineCustomActive: true,
  },
  mutations: {
    setLang(state, lang) {
      state.lang = lang;
    },
    setShowbar(state, showbar) {
      state.showbar = showbar;
    },
    setToolbarItems(state, toolbarItems) {
      state.toolbarItems = toolbarItems;
    },
    setToolbarActive(state, toolbarActive) {
      state.toolbarActive = toolbarActive;
    },
    setOnlineCustomActive(state, active) {
      state.onlineCustomActive = active;
    },
  },
  actions: {
    setLang({ commit }, lang) {
      commit('setLang', lang);
    },
    setShowbar({ commit }, showbar) {
      commit('setShowbar', showbar);
    },
    setToolbarItems({ commit }, toolbarItems) {
      commit('setToolbarItems', toolbarItems);
    },
    setToolbarActive({ commit }, toolbarActive) {
      commit('setToolbarActive', toolbarActive);
    },
    setOnlineCustomActive({ commit }, active) {
      commit('setOnlineCustomActive', active);
    },
  },
  // plugins: [localStoragePlugin],
});
